import { DocumentDatabaseSystem } from '@zvoove-market/api';

export const documentDatabaseSystemDict = {
  [DocumentDatabaseSystem.firebird]: $localize`:@@databaseSystem.firebird:Firebird`,
  [DocumentDatabaseSystem.msSql]: $localize`:@@databaseSystem.mssql:Mssql`,
  [DocumentDatabaseSystem.postgreSql]: $localize`:@@databaseSystem.postgresql:PostgreSql`,
};

export const documentDatabaseSystemItems = Object.entries(documentDatabaseSystemDict).map((x) => ({ id: parseInt(x[0], 10), name: x[1] }));
